/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTExLjk5NjMgMy41TDYuNzQ2MjUgOC43NUwxLjQ5NjI1IDMuNUwwLjg3NSA0LjEyMTI1TDYuNzQ2MjUgOS45OTI1TDEyLjYxNzUgNC4xMjEyNUwxMS45OTYzIDMuNVoiIGZpbGw9IndoaXRlIi8+PC9zdmc+";